import { render, staticRenderFns } from "./ChildPersonalData.vue?vue&type=template&id=325d6a47&scoped=true&"
import script from "./ChildPersonalData.vue?vue&type=script&lang=js&"
export * from "./ChildPersonalData.vue?vue&type=script&lang=js&"
import style0 from "./ChildPersonalData.vue?vue&type=style&index=0&id=325d6a47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d6a47",
  null
  
)

export default component.exports